module.exports = function(value, defaultValue) {
    if (value !== undefined && value !== null)
        return value;
    return defaultValue;
};
